import { InputAdornment, styled, TextField, TextFieldProps } from '@mui/material';
import { filledInputClasses } from '@mui/material/FilledInput';
import { inputBaseClasses } from '@mui/material/InputBase';
import { LwIconButton } from 'redesign';
import { IconCross, IconSearch } from 'assets/img';

type Props = {
  id: string;
  value: string;
  setValue: (value: string) => void;
};

export const FlexWorkersSearchBar = ({ value, setValue }: Props) => {
  return (
    <StyledTextField
      value={value}
      onChange={(e) => setValue(e.target.value)}
      variant="filled"
      fullWidth
      InputProps={{
        startAdornment: (
          <Adornment>
            <StyledIconSearch />
          </Adornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <LwIconButton
              sx={{
                '&:hover': {
                  background: 'none',
                },
              }}
              iconColorMode="stroke"
              color="default"
              aria-label="veld leegmaken"
              onClick={() => setValue('')}
              onMouseDown={(e) => e.preventDefault()}
            >
              <StyledIconCross />
            </LwIconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

const Adornment = styled('span')(({ theme }) => ({
  height: '24px',
  margin: theme.spacing(0, 0, 0, 4),
  width: '24px',
}));

const StyledIconSearch = styled(IconSearch)(({ theme }) => ({
  path: {
    stroke: `${theme.palette.lwPrimaryAccentDark[60]}`,
  },
}));

const StyledIconCross = styled(IconCross)(({ theme }) => ({
  path: {
    stroke: `${theme.palette.lwPrimaryAccentDark[60]}`,
  },
}));

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  margin: theme.spacing(2, 0),
  padding: theme.spacing(0, 1),

  [`& .${filledInputClasses.root}`]: {
    border: `2px solid ${theme.palette.lwPrimaryAccentDark[40]}`,
    borderRadius: theme.spacing(3),
    '&:hover, &.Mui-focused': {
      borderColor: theme.palette.lwPrimaryAccentLight[100],
      boxShadow: `0 0 0 4px ${theme.palette.lwPrimaryAccentLight[10]}`,
    },
    '&.Mui-error': {
      borderColor: theme.palette.lwDanger[100],
      boxShadow: `0 0 0 4px ${theme.palette.lwDanger[20]}`,
    },
  },
  [`& .${inputBaseClasses.input}`]: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));
